export default __webpack_public_path__ + "static/media/placeholder_dummy2016-coach01-mobile-de.409147fd.png";